import { createPinia } from 'pinia'
import {
  Button,
  CellGroup,
  Dialog,
  Empty,
  Field,
  Image as VanImage,
  Loading,
  Popup,
  Search,
  Tag,
} from 'vant'
import { createApp } from 'vue'
import 'vant/lib/index.css'

import App from './App.vue'
import PortalBackButton from './components/PortalBackButton.vue'
import PortalHeroHeader from './components/PortalHeroHeader.vue'
import router from './router'
import './styles/global.css'

const app = createApp(App)

app.component('PortalBackButton', PortalBackButton)
app.component('PortalHeroHeader', PortalHeroHeader)
app.use(createPinia())
app.use(router)
app.use(Button)
app.use(CellGroup)
app.use(Dialog)
app.use(Empty)
app.use(Field)
app.use(Loading)
app.use(VanImage)
app.use(Popup)
app.use(Search)
app.use(Tag)
app.mount('#app')
